<template>
  <a-config-provider :locale="zh_CN">
    <router-view />
  </a-config-provider>
</template>
<script>
import { useStore } from 'vuex';
import { setRouter } from '@/utils/app';
import { provide ,watch} from 'vue';
import {useRoute,useRouter,onBeforeRouteUpdate} from 'vue-router'
import {message,Modal} from 'ant-design-vue';
import store from '@/store'
import zh_CN from 'ant-design-vue/lib/locale-provider/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';
import getUrlKey from './utils/getUrlKey.js'
export default {
  setup(){
    // 监听路由 
    // watch(useRoute(),(newData)=>{
    //   var path=newData.path
    //   var menu=store.state.user.info?store.state.user.info.menu:[]
    //   if(menu){
    //      menu.forEach((v) => {
    //     if (v.key =='/'+ path.split('/')[1]) {
    //       store.dispatch("user/setAsideMenu", v.children);
    //     }
    //   });
    //   }
    // })
    // document.oncontextmenu=function(evt){ 
    //   evt.preventDefault(); 
    //   }
     onBeforeRouteUpdate(to=>{
      var toPath=to
      var paths=toPath.path
      var menu = store.state.user.info ? store.state.user.info.menu : [];
      var newMenu=[]
      if (menu.length&&paths) {
        menu.forEach((v) => {
          if (paths.indexOf(v.url)!=-1) {
                newMenu=v.children
          }
        });
       store.commit("user/SET_ASIDE_MENU", newMenu);
      }
    })
    moment.locale('zh-cn');
    setRouter(useRouter(), useRoute());


    //  依赖注入
    // 路由
    provide('$router',useRouter())
    provide('$route',useRoute())
    // vuex
    provide('$store',useStore())
    // 蚂蚁UI 的方法
    provide('$message',message)
    provide('$Modal',Modal)
    // lodash 工具
    provide('_lodash',require('lodash'))
    // 时间格式化
    provide('momentTime', moment)
    //获取url参数
    provide('$getUrlKey', getUrlKey)
    
    return {
        zh_CN,
    }
  }
};
</script>